module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-5.d5386401.svg";